export const BuildInfo = {timestamp:1776785610000}
